(function () {
  const section = document.getElementById('faq-section');
  if (!section) return;

  const token = section.dataset.storefrontToken;
  const shop = section.dataset.shopDomain;

  // ✅ Read from div attribute first, fallback to URL, fallback to 'home'
  const pageHandle = section.dataset.pageHandle || '';
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const currentHandle = pageHandle || (pathParts.length > 0 ? pathParts[pathParts.length - 1].toLowerCase() : 'home');

  const STOREFRONT_API = `https://${shop}/api/2024-10/graphql.json`;

  const query = `
    {
      metaobjects(type: "faq_entry", first: 250) {
        edges {
          node {
            handle
            fields { key value }
          }
        }
      }
    }
  `;

  function getField(fields, key) {
    const f = fields.find(f => f.key === key);
    return f ? f.value : '';
  }

  function escapeHtml(text) {
    if (!text) return '';
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  fetch(STOREFRONT_API, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token
    },
    body: JSON.stringify({ query })
  })
    .then(res => res.json())
    .then(data => {
      const allEntries = data?.data?.metaobjects?.edges || [];

      const pageEntries = allEntries.filter(({ node }) => {
        const primaryPage = getField(node.fields, 'primary_website_page');
        const pages = primaryPage.split(',').map(p => p.trim().toLowerCase());
        return pages.includes(currentHandle.toLowerCase());
      });

      const loading = document.getElementById('faq-loading');
      const container = document.getElementById('faq-container');

      if (!container || !loading) return;

      if (pageEntries.length === 0) { section.style.display = 'none'; return; }

section.style.display = 'block';


      const topics = {};
      pageEntries.forEach(({ node }) => {
        const topic = getField(node.fields, 'topic') || 'General';
        if (!topics[topic]) topics[topic] = [];
        topics[topic].push(node);
      });

      const topicKeys = Object.keys(topics);

      let tabsHtml = '<div class="niji-faq-tabs-row">';
      topicKeys.forEach((topic, i) => {
        tabsHtml += `
          <button type="button" class="niji-faq-tab-btn ${i === 0 ? 'active' : ''}" data-topic="${escapeHtml(topic)}">
            ${escapeHtml(topic)}
          </button>`;
      });
      tabsHtml += '</div>';

      let panelsHtml = '<div class="niji-faq-categories">';
      topicKeys.forEach((topic, i) => {
        panelsHtml += `
          <div class="niji-faq-category ${i === 0 ? 'active' : ''}" data-panel="${escapeHtml(topic)}">
            <h3 class="niji-faq-category-heading">
              <span class="niji-faq-badge">${i + 1}</span>
              <span>${escapeHtml(topic)}</span>
            </h3>
            <div class="niji-faq-questions">`;

        topics[topic].forEach((node) => {
          const question = getField(node.fields, 'original_questions') || getField(node.fields, 'canonical_question');
          const answer = getField(node.fields, 'detailed_customer_answer');
          panelsHtml += `
            <div class="niji-faq-item">
              <button type="button" class="niji-faq-button" aria-expanded="false">
                <span class="niji-faq-question">${escapeHtml(question)}</span>
                <svg class="niji-faq-chevron" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m6 9 6 6 6-6"></path>
                </svg>
              </button>
              <div class="niji-faq-answer">
                <div class="niji-faq-answer-content">${escapeHtml(answer).replace(/\n/g, '<br>')}</div>
              </div>
            </div>`;
        });

        panelsHtml += `</div></div>`;
      });
      panelsHtml += '</div>';

      container.innerHTML = tabsHtml + panelsHtml;
      loading.style.display = 'none';
      container.style.display = 'block';

      // Tab switching
      document.querySelectorAll('.niji-faq-tab-btn').forEach(tab => {
        tab.addEventListener('click', function () {
          const topic = this.dataset.topic;
          document.querySelectorAll('.niji-faq-tab-btn').forEach(t => t.classList.remove('active'));
          document.querySelectorAll('.niji-faq-category').forEach(p => p.classList.remove('active'));
          this.classList.add('active');
          const panel = document.querySelector(`.niji-faq-category[data-panel="${CSS.escape(topic)}"]`);
          if (panel) panel.classList.add('active');
        });
      });

      // Accordion toggle
      document.querySelectorAll('.niji-faq-button').forEach(btn => {
        btn.addEventListener('click', function () {
          const expanded = this.getAttribute('aria-expanded') === 'true';
          this.setAttribute('aria-expanded', String(!expanded));
          this.closest('.niji-faq-item').classList.toggle('active', !expanded);
        });
      });

      // JSON-LD
      const jsonLd = document.getElementById('faq-jsonld');
      if (jsonLd) {
        const schemaEntries = pageEntries.map(({ node }) => ({
          '@type': 'Question',
          name: getField(node.fields, 'canonical_question'),
          acceptedAnswer: {
            '@type': 'Answer',
            text: getField(node.fields, 'short_ai_answer')
          }
        }));
        jsonLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: schemaEntries
        });
      }
    })
    .catch(err => {
      console.error('FAQ load error:', err);
      const loading = document.getElementById('faq-loading');
      if (loading) loading.style.display = 'none';
    });
})();
